module.exports = __webpack_public_path__ + "assets/media/july-2@2x.aaa681e9.png";